import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import * as actions from "../../../store/slices/AssessmentSlice";
import { useCurrentPatientId } from "../../../hooks/useCurrentPatient";

const useDietPlanData = () => {
  const dispatch = useDispatch();
  const patientId = useCurrentPatientId();
  
  const {
    dietPlanData: { data, isLoading, errors },
  } = useSelector((state: RootState) => state.assessment);

  const fetchDietPlanData = useCallback((assessmentId: string) => {
    if (!patientId) return;

    const payload = {
      patient_id: patientId,
      assessment_id: assessmentId,
    };
    dispatch(actions.getDietPlanDataRequest(payload));
  }, [dispatch, patientId]);

  return {
    data,
    isLoading,
    errors,
    fetchDietPlanData,
  };
};

export default useDietPlanData;
